import React, { useState } from "react"
import { Box, Grid, TextField, Typography } from "@material-ui/core"
import { ToggleBar, ToggleBarButton } from "./ToggleBar"
import CommunicationText from "./CommunicationText"
import CommunicationEmail from "./CommunicationEmail"
import useStyles from "./styles"

const Communication = () => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState(0)

  const tabList = [<CommunicationText />, <CommunicationEmail />]

  return (
    <div>
      <ToggleBar activeTab={activeTab} setActiveTab={setActiveTab}>
        <ToggleBarButton>Text Message</ToggleBarButton>
        <ToggleBarButton>Email</ToggleBarButton>
      </ToggleBar>
      <Box className={classes.pageContainer}>{tabList[activeTab]}</Box>
    </div>
  )
}

export default Communication



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/index.jsx